// Wat de nachtelijke controle gevonden heeft, in gewone taal.
//
// Eén plek, omdat de inzichtkaart en de publicatiesectie op het themadetail
// dezelfde reden moeten noemen — twee lijsten lopen binnen een week uiteen.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

export const DRIFT_LABELS = Object.freeze({
    topRowChanged: 'de bovenste rij is gewisseld',
    qualityDropped: 'de onderbouwing is zwakker geworden',
    measurableLost: 'er is geen meetbare data meer',
    rowsDisappeared: 'een gepubliceerde rij is verdwenen',
    notComputable: 'kon niet opnieuw worden uitgerekend',
})

/**
 * De redenen van een driftmelding als één zin. Een onbekende soort komt
 * onvertaald terug — leeg laten zou de melding zonder reden tonen.
 *
 * @param {{reasons?: Array<{kind: string}>}|null|undefined} drift
 * @returns {string}
 */
export const driftReasons = (drift) => (
    (drift && Array.isArray(drift.reasons) ? drift.reasons : [])
        .map((r) => (r && DRIFT_LABELS[r.kind]) || (r && r.kind) || '')
        .filter(Boolean)
        .join(', ')
)

export default DRIFT_LABELS
